<!--
 * @description: Don't description
 * @Author: Mustafa.Yin
 * @Date: 2022-05-15 19:22:54
 * @FilePath: \smart-reco-xnd:\vue_project\smart-reco-h5\src\components\PageHeader.vue
 * @LastEditTime: 2025-08-24 18:39:51
-->
<template>
<div class="bg-white dark:bg-white">
  <van-row>
    <van-col span="24">
      <div style="background-color: white;"></div>
    </van-col>
  </van-row>
  <van-row>
    <van-col offset="5" span="4" style="text-align: right;">
    </van-col>
    <van-col span="6" style="text-align: center;">
      <router-link to="/home?shopId=2327299222177991915&personId=9113221422322173813&companyId=676344787275836663414260">
        <img :src="logoPng" alt="Logo">
      </router-link>
    </van-col>
    <van-col span="4" style="text-align: left;text-align: center;"></van-col>
  </van-row>
  <van-divider></van-divider>
  </div>
</template>


<script>
import logoPng from '../assets/logo.png';
export default {
  name: "PageHeader",
  setup(){
    return {
      logoPng,
    }
  }
}
</script>

<style scoped>

</style>
